let ipc = null;

if (window && window.require) {
  try {
    const { ipcRenderer } = window.require("electron");

    ipc = {
      send: (channel, data) => ipcRenderer.send(channel, data),
      on: (channel, func) =>
        ipcRenderer.on(channel, (event, ...args) => func(...args)),
      once: (channel, func) =>
        ipcRenderer.once(channel, (event, ...args) => func(...args)),
      removeAll: (channel) => ipcRenderer.removeAllListeners(channel),
    };

    console.log("✅ Dual Display: IPC available");
  } catch (err) {
    console.warn("⚠️ Dual Display: Electron IPC not available", err);
  }
} else {
  ipc = {
    send: () => console.log("Not in Electron, ignoring send()"),
    on: () => console.log("Not in Electron, ignoring on()"),
    once: () => console.log("Not in Electron, ignoring once()"),
    removeAll: () => {},
  };
}

export default ipc;
